import * as React from 'react';

const SvgCurrency = (props) => (
  <svg
    width={15}
    height={13}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.8 10.6c0-4.388-2.865-7.945-6.4-7.945M1 10.6c0-4.388 2.865-7.945 6.4-7.945m0 0v6.62m0-6.62V1'
      stroke='#E00034'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgCurrency;
